// KB = 1000
// MB = 1000000
export const SIZE_LIMIT = 100000000; //10 MB

// Number of files that can be uploaded at once
export const TOTAL_MEDIA_LIMIT = 10;
export const TOTAL_DOCUMENT_LIMIT = 10;
